// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-role__sidenav {
  width: 33vw;
}`, "",{"version":3,"sources":["webpack://./src/app/user-role/user-role-side-nav/user-role-side-nav.component.scss"],"names":[],"mappings":"AACA;EACE,WAAA;AAAF","sourcesContent":["\n.user-role__sidenav {\n  width: 33vw;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
